// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-icon {
  margin-top: 30px;
  font-size: 10rem;
}

.error-message {
  white-space: pre-wrap;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/geo-comply/geo-comply.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,qBAAA;AACJ","sourcesContent":["ion-icon {\r\n    margin-top: 30px;\r\n    font-size: 10rem;\r\n}\r\n\r\n.error-message{\r\n    white-space: pre-wrap;\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
